/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lang_Name_EnInputs */

const en_lang_name_en = /** @type {(inputs: Lang_Name_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de_lang_name_en = /** @type {(inputs: Lang_Name_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englisch`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {Lang_Name_EnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lang_name_en = /** @type {((inputs?: Lang_Name_EnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lang_Name_EnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lang_name_en(inputs)
	return en_lang_name_en(inputs)
});